<template>
  <section id="contact">
    <div class="container">
      <h2>Contact Us</h2>
      <div v-if="!success">
        <div>
          <div class="form-row required" :class="errors && errors.firstName ? 'has-danger' : ''">
            <label class="control-label">First name</label>
            <input v-model="formData.firstName" class="form-control" />
          </div>
          <div class="form-row required" :class="errors && errors.lastName ? 'has-danger' : ''">
            <label class="control-label">Last name</label>
            <input v-model="formData.lastName" class="form-control" />
          </div>
          <div class="form-row">
            <label class="control-label">Company</label>
            <input v-model="formData.company" class="form-control" />
          </div>
          <div class="form-row required" :class="errors && errors.email ? 'has-danger' : ''">
            <label class="control-label">Email</label>
            <input v-model="formData.email" type="email" class="form-control" />
          </div>
          <div class="form-row required" :class="errors && errors.streetAddress ? 'has-danger' : ''">
            <label class="control-label">Street Address</label>
            <input v-model="formData.streetAddress" type="text" class="form-control" />
          </div>
          <div class="form-row required">
            <div class="form-row" :class="errors && errors.city ? 'has-danger' : ''">
              <label class="control-label">City</label>
              <input v-model="formData.city" class="form-control" />
            </div>
            <div class="form-row" :class="errors && errors.state ? 'has-danger' : ''">
              <label class="control-label control-label-inline">State</label>
              <input v-model="formData.state" class="form-control" />
            </div>
            <div class="form-row" :class="errors && errors.zip ? 'has-danger' : ''">
              <label class="control-label control-label-inline">Zip Code</label>
              <input v-model="formData.zip" class="form-control" />
            </div>
          </div>
          <div class="form-row required" :class="errors && errors.phone ? 'has-danger' : ''">
            <label class="control-label">Preferred phone</label>
            <input v-model="formData.phone" type="text" class="form-control" />
          </div>
        </div>
        <div class="reqInfo">
          <p><span :style="{color: 'red'}">*</span>Required information</p>
          <div :style="{marginBottom: '2rem'}">
            <div class="form-check">
              <label class="form-check-label">
                <input v-model="formData.optIns.volunteer" class="form-check-input" type="checkbox"> I would like to volunteer to help at a PFK event
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input v-model="formData.optIns.raiseFunds" class="form-check-input" type="checkbox"> I/My organization would like to raise funds on behalf of PFK
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input v-model="formData.optIns.sponsorEvent" class="form-check-input" type="checkbox"> I/My organization would like to sponsor a PFK event or mission trip or aspect of an event/mission trip
              </label>
            </div>
          </div>
          <div :style="{ position: 'absolute', overflow: 'hidden', height: 0, width: 0 }">
            <input v-model="formData.additionalInformation" type="text">
          </div>
          <div class="form-group">
            <label class="control-label"><strong>Questions / Comments</strong></label>
            <textarea v-model="formData.comments" class="form-control" rows="6"></textarea>
          </div>
          <button v-if="!sending" @click="submit" class="btn btn-lg btn-primary">Send Now</button>
          <button v-if="sending" class="btn btn-lg btn-primary" disabled="true">Send Now</button>
          <div v-if="errors" class="alert alert-danger">
            <strong>Please correct the following errors:</strong>
            <ul>
              <li v-for="error in errors">{{error}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="alert alert-success" v-else>
        <strong>Success!</strong> Thank you for getting in touch.
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'contact-us',
  data () {
    return {
      formData: {
        firstName: null,
        lastName: null,
        company: null,
        email: null,
        streetAddress: null,
        city: null,
        state: null,
        zip: null,
        phone: null,
        comments: null,
        additionalInformation: null,
        optIns: {
          volunteer: false,
          raiseFunds: false,
          sponsorEvent: false
        }
      },
      errors: null,
      success: false,
      sending: false
    }
  },
  methods: {
    submit () {
      const vm = this
      vm.sending = true
      vm.$http.post('/contact', vm.formData)
      .then((response) => {
        vm.sending = false
        if (response.data && response.data.status === 'error') {
          vm.errors = response.data.errors
        } else if (response.data && response.data.status === 'success') {
          vm.errors = null
          vm.success = true
        } else {
          console.log(response.data)
          vm.errors = ['Your message could not be sent']
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~assets/styles/vars';

  .reqInfo {
    @include media('tablet') {
      margin-left: 150px;
    }
  }

  section {
    padding: 80px 0;
    background: lighten($gold, 15%);
  }

  h2 {
    text-align: center;
    margin-bottom: 3rem;
  }

  .form-control {
    flex: 1;
    background: white;
    border-radius: 0;
    border-color: $ltBrown;
  }

  .has-danger {
    .form-control {
      border-color: red;
    }
    label {
      color: red;
    }
  }

  textarea {
    resize: none;
  }

  .alert {
    margin-top: 30px;
    ul {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .form-row {
    margin-bottom: 1rem;
    @include media('tablet') {
      display: flex;
      align-items: center;
      .control-label {
        width: 140px;
        text-align: right;
        margin-right: 10px;
        line-height: 1;
        margin-bottom: 0;
        &.control-label-inline {
          width: auto;
          margin-left: 30px;
        }
      }
      > .form-row {
        flex: 1;
      }
    }
    &.required {
      .control-label:after {
        content: ' *';
        color: red;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ContactUs.vue?6bb38ca3